export enum ApNutrientWizardStep {
  Selection,
  Details,
  Overview
}
